import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './staffPreparationTaskDialog.module.scss'
import UserInput from '@/components/_custom/UserInput/userInput'

interface StaffPreparationTaskFormProps {
    name: string
    setName: (value: string) => void
    duration: string
    setDuration: (value: string) => void
    setDurationValid: (value: boolean) => void
}

const StaffPreparationTaskForm: FunctionComponent<StaffPreparationTaskFormProps> = ({
    name,
    setName,
    duration,
    setDuration,
    setDurationValid
}) => {
    const { t } = useTranslation()

    return (
        <div className={styles.InputContainer}>
            <div className={styles.Input}>
                <UserInput
                    label={t('name')}
                    value={name}
                    type='text'
                    required
                    fullWidth
                    format={'pascal'}
                    className={styles.UserInput}
                    unallowedCharacters={'special'}
                    setValue={setName}
                />
                <UserInput
                    label={t('duration')}
                    value={duration}
                    type='number'
                    required
                    fullWidth
                    format={'num'}
                    className={styles.UserInput}
                    unallowedCharacters={'alpha'}
                    setValue={setDuration}
                    setValid={setDurationValid}
                    minNumber={1}
                    verify={'number'}
                />
            </div>
        </div>
    )
}

export default StaffPreparationTaskForm
